import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @class selectFactory
 *
 */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionRegistrar } from '../../../actions/entityActionRegistrar';
import Search from './search';
const searchFactory = entity => {
  // map the redux store/state into props for this component.
  const mapStateToProps = (state, incomingProps) => _objectSpread(_objectSpread({}, incomingProps), {}, {
    indexQuery: state[entity].indexQuery
  });

  // map the redux dipsatch mechanism into actions prop for this component.
  const mapDispatchToProps = dispatch => {
    const result = {};
    const actions = actionRegistrar(entity);
    if (actions) {
      result.serverFilter = bindActionCreators([actions.serverFilter], dispatch)[0];
    }
    return result;
  };

  // This wraps and instance of an entity in ConnectedClass and
  // connects it to the subset of the redux state as well as the action set
  return connect(mapStateToProps, mapDispatchToProps)(Search);
};
export default searchFactory;